module.exports = __webpack_public_path__ + "img/content6.7af99278.png";